<template>
<div>
  <table class="table">
    <tr>
      <th>
        Nazwa
        <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'name'" :direction="meta.direction"></sorting>

      </th>
      <th>
        Grupa publiczna
        <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'public'" :direction="meta.direction"></sorting>

      </th>
      <th>
        Status
        <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'status'" :direction="meta.direction"></sorting>

      </th>
      <th>
        Akcje
      </th>
    </tr>
    <tr v-for="item in items">
      <td>
        <a class="main-link" @click="$router.push({name: 'admin.email-groups.show', params: {id: item.id}})">{{ item.name }}</a> <span class="gray">({{ item.total_emails }})</span>
      </td>
      <td>
        <span>{{ item.public ? 'Tak' : 'Nie' }}</span>
      </td>
      <td>
        <span>{{ item.status == 1 ? 'Aktywna' : 'Nie aktywna' }}</span>
      </td>

      <td class="actions">
        <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.email-groups.edit', params: {id: item.id}})">Edytuj</ui-button>
        <ui-button type="flat" icon="highlight_off" color="danger" @click.prevent="remove(item)">Usuń</ui-button>
      </td>
    </tr>
  </table>
  <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>

</template>
<script>
import EmailGroups from './../../services/EmailGroups'
import EventEmitter from './../../services/EventEmitter'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  methods: {
    getService () {
      return EmailGroups
    },
    _remove (item) {
      EmailGroups.remove(item.id).then((res) => {
        if (res.status === 204) {
          this.reload()
          this.notify('Usunięto')
        }
      })
    },
    remove (item) {
      EventEmitter.$emit('confirm.show', {
        confirmCb: () => {
          this._remove(item)
        }
      })
    }
  },
  mounted () {
    EventEmitter.$on('email-groups.reload', () => {
      this.meta.current_page = 1
      this.reload()
    })
  }
  // events: {
  //   'email-groups.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }
}

</script>


// WEBPACK FOOTER //
// List.vue?93d01378